import { TableColumnItem, TableColumnTypeEnum } from '@ui-lib/components';

export const getWorkersTableColumnsConfig = (withActions = false): TableColumnItem[] => {
  const columns: TableColumnItem[] = [
    {
      propName: 'worker',
      captionTranslateKey: 'monitoring.workers.columns.worker',
      type: TableColumnTypeEnum.Text,
    },
    {
      propName: 'client',
      captionTranslateKey: 'monitoring.workers.columns.client',
      type: TableColumnTypeEnum.Text,
    },
    {
      propName: 'pool',
      captionTranslateKey: 'monitoring.workers.columns.pool',
      type: TableColumnTypeEnum.Text,
    },
    {
      propName: 'coin',
      captionTranslateKey: 'monitoring.workers.columns.coin',
      type: TableColumnTypeEnum.Text,
    },
    {
      propName: 'device',
      captionTranslateKey: 'monitoring.workers.columns.device',
      type: TableColumnTypeEnum.Text,
    },
    {
      propName: 'status',
      captionTranslateKey: 'monitoring.workers.columns.status',
      type: TableColumnTypeEnum.Text,
    },
    {
      propName: 'hashrate',
      captionTranslateKey: 'monitoring.workers.columns.hashrate',
      type: TableColumnTypeEnum.Text,
    },
  ];

  if (withActions) {
    columns.push({
      propName: 'actions',
      captionTranslateKey: 'monitoring.actions',
      type: TableColumnTypeEnum.Actions,
    });
  }

  return columns;
};
